import { storedUpdateVar, toSendVar } from "src/hooks/useClientUpdate";
import {
	appStateVar,
	clearingVariables,
	gatheringSelectorHasChangeVar,
	grantedContactsVar,
	uploadDownloadToastFocusedVar,
} from "./variables";

export const clearVariables = () => {
	uploadDownloadToastFocusedVar(false);
	grantedContactsVar(undefined);
	appStateVar("active");
	storedUpdateVar(undefined);
	toSendVar({});
	gatheringSelectorHasChangeVar(true);
	for (const { reactiveVar, defaultValue } of clearingVariables) {
		reactiveVar(defaultValue);
	}
};
